"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectSetKeyNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const lodash_1 = __importStar(require("lodash"));
const NODE_TYPE = 'OBJECT-SET-KEY';
class ObjectSetKeyNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const inData = params.input;
            const input = lodash_1.default.cloneDeep(inData);
            if (!input || !params.key) {
                return undefined;
            }
            if (lodash_1.isNil(params.value)) {
                delete input[params.key];
            }
            else {
                input[params.key] = params.value;
            }
            return { result: input };
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        //set up the basic outputParams schema
        const InputParams = {
            type: 'object',
            properties: {
                input: { type: 'object', properties: {}, description: 'input' },
                key: { type: 'string' },
                value: BaseNode_1.BaseNode.getProp(this.config.type, 'value')
            },
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: this._interfaceDefinition.definitions.OutputParams, ConfigParams: {
                type: 'object',
                properties: {
                    type: BaseNode_1.BaseNode.getTypeOptions(true),
                },
            } });
    }
}
exports.ObjectSetKeyNode = ObjectSetKeyNode;
ObjectSetKeyNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Object Set Key',
    isIdempotent: true,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ObjectSetKey.js.map